var PES = PES || {};

PES.ExcelTimeline = function () {

    var init = function () {

        $('.zoom').each(function () { $(this).zoom(); });

        $('.modal-window').click(function (e) {
            e.preventDefault();
            window.open($(this).attr('href'), 'fbShareWindow', 'height=450, width=550, top=' + ($(window).height() / 2 - 275) + ', left=' + ($(window).width() / 2 - 225) + ', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0');
            return false;
        });

        $("a.toggle-list-size").on("click", function () {
            $("div.templates-list").toggleClass("collapsed");
            $("span.state-collapsed").toggle();
            $("span.state-uncollapsed").toggle();
            $(this).toggleClass("margin-top-small");
            $(".toggle-list").toggleClass("faded");
        });

        $(".header-video-thumbnail>a").on("click", function (evt) {
            $(this).hide();
            var iframe = $(this).parent().find("iframe");
            iframe.show();
            iframe.attr("src", $(iframe).attr("src") + "?autoplay=1");

            return false;
        });

        $(".articles__mobile .form-control").on("change", function () {
            window.location = $(this).val();
        });

    };
    return {
        init: init
    };
}();